import { Expose } from 'class-transformer';
import AddressFormError from 'errors/AddressFormError';

export default class AdminPracticeCreationFormError extends AddressFormError {
    email: string[] = []
    first_name: string[] = []
    last_name: string[] = []
    affiliate_code: string[] = []
    marketing_channel: string[] = []
    billing_name: string[] = []
    billing_email: string[] = []
    payment_option: string[] = []
    invoice_due_days: string[] = []
    default_settlement_days: string[] = []
    name: string[] = []
    tz: string[] = []
    email_for_inquiries: string[] = []
    email_for_notifications: string[] = []
    phone_for_inquiries: string[] = []
    phone_for_notifications: string[] = []
    start_time: string[] = []
    end_time: string[] = []
    lunch_break: string[] = []
    description: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}